'use strict';

import {isEqualIncident} from 'components/user_area/my_trips/js/utils/booking_detail_utils';

export const TRACKING = {
    CANCELLATION_ACTION: 'cancellation',
    ITINERARY_MORE_INFO_PREFIX: 'click_info',
    TRIP_DETAILS_CATEGORY: 'my_area_trips_details',
    ITINERARY_MORE_INFO_PARAMS: ['booking', 'status', 'id', 'pag'],
    WIDGET_SUMMARY_ACTION: 'widget_summary',
};

export const CSS_CLASSES = {
    ODF_HIDDEN: 'odf-hidden',
    ODF_ICON_2XL: 'odf-icon-2xl',
    ODF_INLINE_MIDDLE: 'odf-inline-middle',
};

export const extendBookingDetailSegments = (bookingDetail) => {
    const itinerarySegments = Odigeo._.get(bookingDetail, 'itineraryBookings.itinerarySegments', []);
    const {shouldHideAllProductOffers, incidents} = bookingDetail;
    itinerarySegments.forEach((segment, index) => {
        const nextSegmentFirstSectionDeparture = Odigeo._.get(itinerarySegments[index + 1], 'sections[0].section.departureDate', null);
        const currentSegmentLastSectionArrival = Odigeo._.get(Odigeo._.last(segment.sections), 'section.departureDate', null);
        segment.nightsInSegmentArrivalCity = Odigeo.Utils.getDifferenceInDays(currentSegmentLastSectionArrival, nextSegmentFirstSectionDeparture);
        segment.hasSegmentContextualOffers = Odigeo.Utils.isDesktop() && !shouldHideAllProductOffers && (index === 0);
        segment.lastSectionProductType = Odigeo._.get(Odigeo._.last(segment.sections), 'section.productType', null);

        extendSectionsWithStatusData(bookingDetail.bookingProductStatus, segment, index, incidents);
        setSegmentTransportType(segment);
    });
};

const setSegmentTransportType = (segment) => {
    const reducer = (initValue, section) => (!Odigeo._.isEmpty(initValue) &&
        initValue !== section.section.productType) ? ' MULTI_TRANSPORT' : section.section.productType;
    segment.transportType = segment.sections.reduce(reducer, '');
};

const getRelatedIncident = (section, incidents) => incidents.find((incident) => isEqualIncident(section, incident, incident.providerBookingItemId));

const extendSectionWithProductStatusInfo = (section, incident)=>{
    const PRODUCT_STATUS = {
        CONTRACT: {
            flightStatusIcon: incident ? 'odf-icon-cross-circle-light' : 'odf-icon-tick-circle',
            flightStatusTextColor: incident ? 'odf-text-negative' : 'odf-text-positive',
            flightStatusCtaClass: 'odf-clickable flight_status_more_info',
            flightStatusClass: incident ? 'altered' : '',
            productStatus: incident ? 'CANCELLED' : 'CONFIRMED',
            productStatusTitle: incident ? 'flightStatusCancelled' : 'CONFIRMEDProductStatus',
        },
        DIDNOTBUY: {
            flightStatusIcon: 'odf-icon-cross-circle-light',
            flightStatusTextColor: 'odf-text-negative',
            flightStatusCtaClass: '',
            flightStatusClass: '',
            productStatus: 'CANCELLED',
            productStatusTitle: 'CANCELLEDProductStatus',
        },
    };
    section = Object.assign(section, {incident}, (PRODUCT_STATUS[section.productStatus] || {productStatus: 'PENDING'}));
};

const extendSectionsWithStatusData = (bookingProductStatus, segment, index, incidents = []) => {
    const productStatusByBookingProductStatus = {
        PENDING: 'PENDING',
        CANCELLED: 'DIDNOTBUY',
    };
    segment.sections.forEach((section) => {
        if (Odigeo.AB.isBookingImportantMessage) {
            const incident = getRelatedIncident(section, incidents);
            let {isFlightStatusAltered = false, sectionStatus = []} = segment;
            section.productStatus = bookingProductStatus === 'PENDING' || bookingProductStatus === 'CANCELLED'
                ? productStatusByBookingProductStatus[bookingProductStatus]
                : section.productStatus;
            extendSectionWithProductStatusInfo(section, incident);
            segment.isFlightStatusAltered = isFlightStatusAltered || !!incident;
            segment.sectionStatus = incident && [...sectionStatus, incident.status];
        } else {
            const isFlightStatusAltered = Odigeo._.get(section, 'section.flightStatus', '') === 'CANCELLED';
            section.isFlightStatusAltered = isFlightStatusAltered;
            segment.isFlightStatusAltered = segment.isFlightStatusAltered || isFlightStatusAltered;
            section.segmentIndex = section.segmentIndex || index;

            if (isFlightStatusAltered) {
                section.flightStatusIcon = 'odf-icon-cross-circle-light';
                section.flightStatusTextColor = 'odf-text-negative';
                section.flightStatusCtaClass = 'odf-clickable flight_status_more_info';
                section.flightStatusClass = 'altered';
            } else {
                section.flightStatusIcon = 'odf-icon-tick-circle';
                section.flightStatusTextColor = 'odf-text-positive';
                section.flightStatusCtaClass = '';
                section.flightStatusClass = '';
            }
        }
    });
};
